import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Clock, ArrowLeft, Sparkles } from 'lucide-react';
import PageTransition from '../../components/common/PageTransition';
import SEOHead from '../../components/common/SEOHead';
import SectionHeader from '../../components/common/SectionHeader';

const Commissions: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageTransition>
      <SEOHead title={t('art.commissions.title')} />
      <div className="space-y-8 max-w-4xl mx-auto">
        {/* Back navigation */}
        <Link
          to="/art#commissions"
          className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-brand-amber transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          {t('art.projects.backToArt')}
        </Link>

        <SectionHeader
          title={t('art.commissions.title')}
          description={t('art.commissions.description')}
          iconName="Brush"
          variant="art"
          badge={t('nav.art')}
        />

        {/* Status Alert */}
        <div className="bg-brand-amber/10 border border-brand-amber/30 rounded-xl p-4 flex items-start gap-3">
          <Clock className="w-5 h-5 text-brand-amber shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-brand-amber">
              {t('art.commissions.status')} : {t('art.commissions.statusOpen')}
            </h4>
            <p className="text-sm text-brand-amber/80">
              {t('art.commissions.statusDesc')}
            </p>
          </div>
        </div>

        {/* Types of Commissions */}
        <div className="art-card p-6 rounded-2xl border-brand-amber/30 space-y-6">
          <div className="flex items-start gap-4">
            <div className="p-3 bg-brand-amber/10 rounded-xl text-brand-amber shrink-0">
              <Sparkles className="w-6 h-6" />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-2">
                {t('art.commissions.whatIsTitle')}
              </h2>

              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                {t('art.commissions.whatIsText')}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-4">
              <h3 className="font-bold text-slate-900 dark:text-white mb-2">
                {t('art.commissions.uniqueTitle')}
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                {t('art.commissions.uniqueText')}
              </p>
            </div>

            <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-4">
              <h3 className="font-bold text-slate-900 dark:text-white mb-2">
                {t('art.commissions.collabTitle')}
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                {t('art.commissions.collabText')}
              </p>
            </div>

            <div className="rounded-xl border border-slate-200 dark:border-slate-800 p-4">
              <h3 className="font-bold text-slate-900 dark:text-white mb-2">
                {t('art.commissions.qualityTitle')}
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed">
                {t('art.commissions.qualityText')}
              </p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center pt-4">
          <a
            href="/contact"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-xl bg-brand-amber hover:bg-amber-400 text-slate-900 font-bold text-lg transition-all shadow-lg shadow-brand-amber/20"
          >
            {t('art.commissions.requestQuote')}
          </a>
        </div>
      </div>
    </PageTransition>
  );
};

export default Commissions;
